import React, { useEffect } from 'react';
import './Services.scss';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';

const Services = () => {
  useEffect(() => {
    setPageTitle('Our Services');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
  ];

  return (
    <div className="services-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Services</h1>
        </div>
      </section>

      <section className="services-section section section--light">
        <div className="container">
          <div className="section__header">
            <p className="section__subtitle">A Combination You Won't Find Anywhere Else</p>
            <h2 className="section__title">Our Service Offerings</h2>
            <p className="section__description">
              We sell packaged offerings for implementing cloud and AI security postures, and
              establishing and implementing the full IT Compliance (GRC) program for your business.
            </p>
          </div>

          <div className="services__grid">
            {/* Service cards */}
            <div className="card service-card">
              <h3 className="card__title">Cloud Infrastructure Design and Implementation</h3>
              <p className="card__description">
                We design robust, optimized cloud infrastructures on AWS to drive the operational
                excellence of your SaaS, Data, and AI/ML solutions.
              </p>
              <a href="/solutions/infrastructure" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Orchestration of App, AI/ML, and Data Workloads</h3>
              <p className="card__description">
                We streamline the orchestration of application and data workloads on AWS ECS and AWS
                EKS, ensuring scalability, resilience, and efficiency for your cloud-native
                solutions.
              </p>
              <a href="/solutions/ai-security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Expert FinOps Solutions for AWS</h3>
              <p className="card__description">
                We help you achieve cost efficiency on AWS by analyzing your cloud usage,
                identifying opportunities to reduce waste, and implementing tailored strategies to
                maximize performance while minimizing expenses.
              </p>
              <a href="/solutions/finops" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Cloud Security Posture on AWS</h3>
              <p className="card__description">
                We implement strong, optimized cloud security that provides excellent protection of
                your and your customers' data, and adheres to regulatory standards.
              </p>
              <a href="/solutions/security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">Secure and Privacy-Enhanced AI Implementation</h3>
              <p className="card__description">
                We implement secure AI/ML solutions, including LLMs and custom models, deploy them
                to your cloud environment, set up robust guardrails, and establish comprehensive
                operational governance.
              </p>
              <a href="/solutions/ai-security" className="card__link">
                Read More →
              </a>
            </div>

            <div className="card service-card">
              <h3 className="card__title">IT Compliance Program Implementation</h3>
              <p className="card__description">
                We provide guidance and aid with the implementation of administrative and technical
                safeguards in your organization to ensure successful compliance certification.
              </p>
              <a href="/solutions/compliance" className="card__link">
                Read More →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
